import { render } from "./file-table.vue?vue&type=template&id=43ab7884"
import script from "./file-table.vue?vue&type=script&lang=js"
export * from "./file-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__